export default __webpack_public_path__ + "static/media/search-black.610c44f9.svg";